/**
 * Game class
 * @Readme : public/theme/cnosf/page/je-m-evalue/game/readme.md
 */
class Game {
    /**
     * Constructor
     */
    constructor(game) {
        /**
         * @type {HTMLElement}
         */
        this.game = game;
        /**
         * @type {{}}
         */
        this.gameData = {};
        /**
         * @type {number}
         */
        this.gameId = parseInt(this.game.querySelector("input[name='game_id']").value);
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.showEventElements = this.game.querySelectorAll('[data-show-element]');
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.hideEventElements = this.game.querySelectorAll('[data-hide-element]');
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.sendAjaxButtton = this.game.querySelectorAll('[data-post-ajax]');
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.gameDragAndDrop = this.game.querySelectorAll('.game-drag');
        /**
         * @type {NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element> | NodeListOf<SVGElementTagNameMap[[string]]>}
         */
        this.dataDisabledCheckbox = this.game.querySelectorAll('[data-disabled-checkbox]');
        /**
         * Init
         */
        this._init();
    }

    /**
     * Init
     * @private
     */
    _init() {
        // Get current game data
        GameAsync.get(this.gameId).then((response) => {
            this.gameData = JSON.parse(response);
            this._onDataReady();
        }).catch((e) => {
            alert('Un problème est survenu pendant la récupération des données du jeu.');
            console.log(e);
        });
    }

    /**
     * On data ready
     * @private
     */
    _onDataReady() {
        this._bindInputValue();
        this._addListener();
        // Load game drag and drop if needed
        for (let i = 0; i < this.gameDragAndDrop.length; i++) {
            new GameDragAndDrop(this.gameDragAndDrop[i]);
        }
    }

    /**
     * Add game listener
     * @private
     */
    _addListener() {
        const CHECK_BOX = document.querySelectorAll("input[type='checkbox']");

        for (let i = 0; i < this.showEventElements.length; i++) {
            this.showEventElements[i].addEventListener('click', () => Game._showElement(this.showEventElements[i]));
        }
        for (let i = 0; i < this.hideEventElements.length; i++) {
            this.hideEventElements[i].addEventListener('click', () => Game._hideElement(this.hideEventElements[i]));
        }
        for (let i = 0; i < this.sendAjaxButtton.length; i++) {
            this.sendAjaxButtton[i].addEventListener('click', () => Game._sendAjaxForm(this.sendAjaxButtton[i]));
        }
        for (let i = 0; i < CHECK_BOX.length; i++) {
            CHECK_BOX[i].addEventListener('click', () => Game._changeCheckBox(CHECK_BOX[i]));
        }
        for (let i = 0; i < this.dataDisabledCheckbox.length; i++) {
            if (this.dataDisabledCheckbox[i].checked) {
                Game.disableChoice(this.dataDisabledCheckbox[i])
            }
            this.dataDisabledCheckbox[i].addEventListener('click', (e) => Game.clickDisableChoice(e));
        }
    }

    /**
     * Bind value to input
     * @private
     */
    _bindInputValue() {
        const INPUTS = document.querySelectorAll('input[id^=response_]');

        for (let i = 0; i < INPUTS.length; i++) {
            const RESPONSE_ID = INPUTS[i].id.split('_')[1];
            const ANSWER_ID = RESPONSE_ID.split('-')[1];
            const STATUS_INDEX = RESPONSE_ID.split('-')[2];
            const USER_ANSWER = parseInt((this.gameData.responses[ANSWER_ID].status[STATUS_INDEX]));

            // Set all input value
            INPUTS[i].value = USER_ANSWER;

            // Set checkbox checked
            if (INPUTS[i].type === 'checkbox' && USER_ANSWER) {
                INPUTS[i].checked = true;
            }

            // Set curved position
            if (INPUTS[i].getAttribute('data-curved') && INPUTS[i].value === '1') {
                CNOSF_APP.getModule('CurvedSlider').answer(INPUTS[i].getAttribute('data-curved'));
            }
        }

        // Set data curved input to false (no)  if no user data
        const CURVED_INPUT = document.querySelectorAll('[data-curved]');
        let curved_input_empty = true;

        for (let i = 0; i < CURVED_INPUT.length; i++) {
            if (CURVED_INPUT[i].value === '1') {
                curved_input_empty = false;
            }
        }

        if (CURVED_INPUT.length > 0 && curved_input_empty) {
            CURVED_INPUT[0].value = '1';
        }

        // Set swap cursor to false (no)  if no user data
        const SWAP_CURSORS = document.getElementsByClassName('swap-cursor');

        for (let i = 0; i < SWAP_CURSORS.length; i++) {
            const CHECKBOXES = SWAP_CURSORS[i].querySelectorAll('input[type=checkbox]');

            let checkboxIsEmpty = true;

            for (let j = 0; j < CHECKBOXES.length; j++) {
                if (CHECKBOXES[j].value === '1') {
                    checkboxIsEmpty = false;
                }
            }

            if (CHECKBOXES.length > 0 && checkboxIsEmpty) {
                CHECKBOXES[0].value = '1';
                CHECKBOXES[0].checked = true;
            }
        }

        Game.setStateSecondaryQuestion();
    }

    /**
     * Set state secondary question
     */
    static setStateSecondaryQuestion() {
        const MAIN_STEP = document.getElementById('game-main-question');
        const SECONDARY_STEP = document.getElementById('game-secondary-question');
        const BTN = document.getElementById('show-secondary-step');
        const INPUT_MAIN = MAIN_STEP.querySelectorAll('input');
        let input_main_empty = true;

        if (SECONDARY_STEP && !SECONDARY_STEP.hasAttribute('data-every-enabled')) {
            // Each question can disabled secondary question"
            for (let i = 0; i < INPUT_MAIN.length; i++) {
                if (INPUT_MAIN[i].value === '1' && !INPUT_MAIN[i].hasAttribute('data-disabled-secondary-question')) {
                    input_main_empty = false;
                }
            }

            if (input_main_empty) { // if required answer main step is required for enabled secondary step is empty
                MAIN_STEP.querySelector('[id^="button-to-step-"]').style.display = 'block';
                SECONDARY_STEP.style.display = 'none';
                BTN.disabled = true;

                // Set all field to 0, not checked & not selected
                const INPUT_SECONDARY_STEP = SECONDARY_STEP.querySelectorAll('input');

                for (let i = 0; i < INPUT_SECONDARY_STEP.length; i++) {
                    INPUT_SECONDARY_STEP[i].value = '0';
                    INPUT_SECONDARY_STEP[i].selected = false;
                    INPUT_SECONDARY_STEP[i].checked = false;
                }
            } else {
                BTN.disabled = false;
            }
        }
    };

    /**
     * Event change checkbox
     * @param element
     * @private
     */
    static _changeCheckBox(element) {
        const IS_SWAP_CURSOR = element.parentNode.classList.contains('swap-cursor');

        // Swap cursor
        if (IS_SWAP_CURSOR) {
            Game._setStateSwapCursor(element.parentNode)
        } else {
            // Force checkbox value 0/1
            if (element.checked) {
                element.value = 1;
            } else {
                element.value = 0;
            }
        }

        Game.setStateSecondaryQuestion();
    }

    /**
     * Set set swap cursor
     * @param swapCursor (.swap-cursor)
     * @private
     */
    static _setStateSwapCursor(swapCursor) {
        const TOOLTIP = swapCursor.querySelector('.tooltip');
        const INPUTS = swapCursor.querySelectorAll('input');
        const NO = INPUTS[0];
        const YES = INPUTS[1];

        if (YES.checked) {
            YES.value = '1';
            NO.value = '0';
            NO.checked = false;
            if (TOOLTIP) {
                TOOLTIP.querySelector('i').style.display = 'none';
            }
        } else {
            YES.value = '0';
            NO.value = '1';
            NO.checked = true;

            if (TOOLTIP) {
                TOOLTIP.querySelector('i').style.display = 'block';
            }
        }
    }

    /**
     * Event data send ajax form
     * @param element
     * @private
     */
    static _sendAjaxForm(element) {
        const FORM_DATA = new FormData(element.closest('form'));
        GameAsync.post(FORM_DATA).catch((e) => {
            console.log(e);
        });
    }

    /**
     * Event data show element
     * @param element
     * @private
     */
    static _showElement(element) {
        const ID_ELEMENT_TO_SHOW = element.getAttribute('data-show-element');
        const ELEMENT = document.getElementById(ID_ELEMENT_TO_SHOW);

        ELEMENT.style.display = 'block';
        setTimeout(() => {
            new SmoothScroll(ELEMENT);
        }, 1);
    }

    /**
     * Event data hide element
     * @param element
     * @private
     */
    static _hideElement(element) {
        const ID_ELEMENT_TO_HIDE = element.getAttribute('data-hide-element');

        document.getElementById(ID_ELEMENT_TO_HIDE).style.display = 'none';
    }

    /**
     * Disable choice
     * @param el
     */
    static disableChoice(el) {
        const ARRAY_ID_TO_DISABLED = el.getAttribute('data-disabled-checkbox').split(',');
        for (let i = 0; i < ARRAY_ID_TO_DISABLED.length; i++) {
            const EL = document.getElementById(ARRAY_ID_TO_DISABLED[i]);
            EL.value = '0';
            EL.checked = false;
        }
        el.classList.add('active');
    }

    /**
     * Disabled all check box with value param "data-disabled-checkbox"
     * @param e
     * @param id
     * @constructor
     */
    static clickDisableChoice(e, id) {
        const TARGET = e.target;
        const ARRAY_ID_TO_DISABLED = TARGET.getAttribute('data-disabled-checkbox').split(',');

        for (let i = 0; i < ARRAY_ID_TO_DISABLED.length; i++) {
            const EL = document.getElementById(ARRAY_ID_TO_DISABLED[i]);

            EL.value = '0';
            EL.checked = false;
            TARGET.classList.add('active');
        }

        Game.setStateSecondaryQuestion();
    }
}